import type { AccordionItemProps } from '@faststore/ui'
import {
  AccordionButton as UIAccordionButton,
  AccordionItem as UIAccordionItem,
  AccordionPanel as UIAccordionPanel,
  Icon as UIIcon,
} from '@faststore/ui'
import { forwardRef } from 'react'
import Icon from 'src/components/ui/Icon'

interface Props extends AccordionItemProps {
  /**
   * Attribute to check whether the item is expanded or not.
   */
  isExpanded: boolean
  /**
   * Label for Accordion button
   */
  buttonLabel?: string
  iconNameExpanded?: string
  iconNameContracted?: string
  accordionItemClass?: string
}

const AccordionItem = forwardRef<HTMLDivElement, Props>(function AccordionItem(
  {
    children,
    isExpanded,
    index = 0,
    buttonLabel = '',
    iconNameExpanded,
    iconNameContracted,
    accordionItemClass,
    testId = 'store-accordion-item',
    ...otherProps
  },
  ref
) {
  return (
    <UIAccordionItem
      ref={ref}
      index={index}
      data-testid={`${testId}-item`}
      data-fs-accordion-item
      {...otherProps}
    >
      <UIAccordionButton
        className={`text__title-subsection accordion-item ${
          accordionItemClass ?? ''
        }`}
        aria-label={buttonLabel}
        data-fs-accordion-item-button
        data-testid={`${testId}-button`}
        id={`${testId}-button`}
      >
        {buttonLabel}
        <UIIcon
          data-testid={`${testId}-button-icon`}
          data-fs-accordion-item-button-icon
          component={
            <>
              <Icon
                data-icon={isExpanded ? 'expanded' : true}
                name={iconNameExpanded ?? 'Minus'}
                width={24}
                height={24}
                color="#E5002B"
              />
              <Icon
                data-icon={isExpanded ? true : 'collapsed'}
                name={iconNameContracted ?? 'Plus'}
                width={24}
                height={24}
                color="#E5002B"
              />
            </>
          }
        />
      </UIAccordionButton>
      <UIAccordionPanel
        data-testid={`${testId}-panel`}
        id={`${testId}-panel`}
        data-fs-accordion-item-panel
      >
        {children}
      </UIAccordionPanel>
    </UIAccordionItem>
  )
})

export default AccordionItem
